import { inject, Injectable } from '@angular/core';
import { SectionMasterCreateBulkRequestDTO, SectionMasterCreateRequestDTO, SectionMasterDeleteRequestDTO, SectionMasterDTO, SectionMasterGetPendingFeeByClassIdList, SectionMasterGetPendingFeeByClassIdRequestDTO, SectionMasterGetPendingFeeByClassIdResponseDTO, SectionMasterList, SectionMasterReadByClassIdRequestDTO, SectionMasterReadByIdRequestDTO, SectionMasterUpdateRequestDTO } from './section-master.interface';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { SectionMaster_Create, SectionMaster_Update, SectionMaster_ReadAll, SectionMaster_Delete, SectionMaster_ReadById, SectionMaster_ReadByClassId, SectionMaster_CreateBulk, SectionMaster_GetPendingFeeByClassId } from 'src/app/GlobalVariable';

@Injectable({
  providedIn: 'root'
})
export class SectionMasterService {

  constructor() { }

  http = inject(HttpClient)

  SectionMaster_Create(data: SectionMasterCreateRequestDTO): Observable<SectionMasterDTO> {
    return this.http.post<SectionMasterDTO>(SectionMaster_Create, data)
  }

  SectionMaster_Update(data: SectionMasterUpdateRequestDTO): Observable<SectionMasterDTO> {
    return this.http.post<SectionMasterDTO>(SectionMaster_Update, data)
  }

  SectionMaster_ReadAll(): Observable<SectionMasterList> {
    return this.http.get<SectionMasterList>(SectionMaster_ReadAll)
  }

  SectionMaster_Delete(data: SectionMasterDeleteRequestDTO): Observable<void> {
    return this.http.post<void>(SectionMaster_Delete, data)
  }

  SectionMaster_ReadById(data: SectionMasterReadByIdRequestDTO): Observable<SectionMasterDTO> {
    return this.http.post<SectionMasterDTO>(SectionMaster_ReadById, data)
  }

  SectionMaster_ReadByClassId(data: SectionMasterReadByClassIdRequestDTO): Observable<SectionMasterList> {
    return this.http.post<SectionMasterList>(SectionMaster_ReadByClassId, data)
  }

  SectionMaster_CreateBulk(data: SectionMasterCreateBulkRequestDTO): Observable<SectionMasterList> {
    return this.http.post<SectionMasterList>(SectionMaster_CreateBulk, data);
  };

  SectionMaster_GetPendingFeeByClassId(data: SectionMasterGetPendingFeeByClassIdRequestDTO): Observable<SectionMasterGetPendingFeeByClassIdResponseDTO[]> {
    return this.http.post<SectionMasterGetPendingFeeByClassIdResponseDTO[]>(SectionMaster_GetPendingFeeByClassId, data);
  };
}
